import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

const NoPage = () => {
  return (
    <Container>
      <ErrorCode>404</ErrorCode>
      <ErrorMessage>
        Sorry, the page you are looking for does not exist.
      </ErrorMessage>
      <HomeLink to="/">Go Back to Home</HomeLink>
      <Image src="/path-to-your-image/404-error.png" alt="404 illustration" />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  padding: 0 20px;
  background-color: #f8f9fa;
  font-family: "Roboto Condensed", sans-serif;
  text-align: center;
`;

const ErrorCode = styled.h1`
  font-size: 6rem;
  color: #343a40;
  margin: 0;
  @media (max-width: 768px) {
    font-size: 4rem;
  }
  @media (max-width: 480px) {
    font-size: 3rem;
  }
`;

const ErrorMessage = styled.p`
  font-size: 1.5rem;
  color: #555;
  margin: 1rem 0;
  @media (max-width: 768px) {
    font-size: 1.3rem;
  }
  @media (max-width: 480px) {
    font-size: 1rem;
  }
`;

const HomeLink = styled(Link)`
  background-color: black;
  color: white;
  padding: 0.75rem 1.5rem;
  text-decoration: none;
  border-radius: 4px;
  font-size: 1rem;
  margin-top: 2rem;
  &:hover {
    background-color: #343a40;
  }
`;

const Image = styled.img`
  width: 300px;
  margin-top: 2rem;
  @media (max-width: 768px) {
    width: 200px;
  }
  @media (max-width: 480px) {
    width: 150px;
  }
`;

export default NoPage;
